import { Size } from '@soluto-private/mx-asurion-ui-react-v3';

export const DisplaySize = {
    Small: `@media (max-width: ${Size.MD2 - 1}px)`,
    Large: `@media (min-width: ${Size.MD2}px)`,
};
